import { AxiosPromise } from 'axios';
import { CollectionFunctionFormData } from 'data/collectionFunction/collectionFunction.types';
import Http from '../../shared/http';
import { ServerResponse, WithAuditDetails } from '../types';
import {
  XtpXdpConnection,
  XtpXdpConnectionProtocol,
  API_PATH_XTP_XDP_CONNECTION,
  API_PATH_XTP_XDP_CONNECTION_CF,
} from './xtp-xdp-connection.types';

const http = Http.getHttp();

export function getXtpXdpsConnectionList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<XtpXdpConnection>> {
  return http.get(`${API_PATH_XTP_XDP_CONNECTION}/${deliveryFunctionId}`);
}

export function getXtpXdpsConnection(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<XtpXdpConnection>> {
  return http.get(`${API_PATH_XTP_XDP_CONNECTION_CF}/${deliveryFunctionId}/${id}`);
}

export function createXtpXdpsConnection(
  deliveryFunctionId: string,
  body: WithAuditDetails<CollectionFunctionFormData>,
): AxiosPromise<ServerResponse<any>> {
  return http.post(`${API_PATH_XTP_XDP_CONNECTION_CF}/${deliveryFunctionId}`, body);
}

export function updateXtpXdpsConnection(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<XtpXdpConnection>,
): AxiosPromise<ServerResponse<XtpXdpConnection>> {
  return http.put(`${API_PATH_XTP_XDP_CONNECTION}/${deliveryFunctionId}/${id}`, body);
}

export function deleteXtpXdpsConnection(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<XtpXdpConnection>> {
  return http.delete(`${API_PATH_XTP_XDP_CONNECTION_CF}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}

export function getXtpXdpsConnectionProtocolList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<XtpXdpConnectionProtocol>> {
  return http.get(`${API_PATH_XTP_XDP_CONNECTION}/${deliveryFunctionId}`);
}

export function getXtpXdpsConnectionProtocol(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<XtpXdpConnectionProtocol>> {
  return http.get(`${API_PATH_XTP_XDP_CONNECTION}/${deliveryFunctionId}/${id}`);
}

export function createXtpXdpsConnectionProtocol(
  deliveryFunctionId: string,
  body: WithAuditDetails<XtpXdpConnectionProtocol>,
): AxiosPromise<ServerResponse<XtpXdpConnectionProtocol>> {
  return http.post(`${API_PATH_XTP_XDP_CONNECTION}/${deliveryFunctionId}`, body);
}

export function updateXtpXdpsConnectionProtocol(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<XtpXdpConnectionProtocol>,
): AxiosPromise<ServerResponse<XtpXdpConnectionProtocol>> {
  return http.put(`${API_PATH_XTP_XDP_CONNECTION}/${deliveryFunctionId}/${id}`, body);
}

export function deleteXtpXdpsConnectionProtocol(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void> | WithAuditDetails<XtpXdpConnectionProtocol>,
): AxiosPromise<ServerResponse<XtpXdpConnectionProtocol>> {
  return http.delete(`${API_PATH_XTP_XDP_CONNECTION}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
